import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_ADDRESSES,
  FETCH_COMPANIES_TRADES,
  FETCH_COMPANY_ADDRESS_FOR_WEB,
  FETCH_COMPANY_TRADES_FOR_WEB,
  FETCH_FOLLOW_ENTITIES,
  GET_MANUFACTURER_DETAILS_FOR_WEB,
  SAVE_FOLLOW_ENTITIES
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import {
  AppBar,
  Box,
  Card,
  CardHeader,
  CardMedia,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import PictureViewer from "../common/PictureViewer";
import { BIBlue, BIRed } from "../../assets/helpers";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VerifiedIcon from "@mui/icons-material/Verified";
import Loader from "../../common/Loader";
import ManufactureAboutSection from "./ManufactureAboutSection";
import ManufactureProductSection from "./ManufactureProductSection";
import ManufacturedProducts from "./ManufacturedProducts";
import ManufactureProjectSection from "./ManufactureProjectSection";
import SendInChatModal from "../common/SendInChatModal";
import NoSuchPage from "../common/NoSuchPage";
import { Getrequestcall } from "../../request/Getrequest";
import { SignInCard } from "../common/SignInCard";
import { setShowReport } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import companyPlaceholder from "../../assets/images/avtar_placeholder.jpeg";
import Pages from "../../constant/ReportModel";
import ManufacturerSiteSection from "./ManufacturerSiteSection";
import ManufactureDocumentSection from "./ManufactureDocumentSection";

const ManufactureProfile = () => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Manufacturers || {};

  const { TEXT_SITES = English.Companies.TEXT_SITES } = multiLanguageData?.Companies || {};

  const {
    TEXT_MANUFACTURER_PROFILES = English.Manufacturers.TEXT_MANUFACTURER_PROFILES,
    TEXT_MANUFACTURER = English.Manufacturers.TEXT_MANUFACTURER,
    TEXT_PRODUCTS = English.Manufacturers.TEXT_PRODUCTS,
    TEXT_PROJECTS = English.Manufacturers.TEXT_PROJECTS,
    BUTTON_SEND_IN_CHAT = English.Manufacturers.BUTTON_SEND_IN_CHAT,
    BUTTON_SHARE = English.Manufacturers.BUTTON_SHARE,
    BUTTON_REPORT = English.Manufacturers.BUTTON_REPORT,
    TEXT_ABOUT_INFO = English.Manufacturers.TEXT_ABOUT_INFO
  } = LanguageData || {};

  const [manufactureData, setManufatureData] = useState({
    manufactureDetails: null,
    tradeList: [],
    manufactureAddress: [],
    followDetails: null
  });

  // Different tab configurations for verified/unverified
  const verifiedTabs = [
    { id: "1", label: TEXT_ABOUT_INFO },
    { id: "3", label: "Product used" },
    { id: "5", label: "Products Manufactured" },
    { id: "2", label: TEXT_PROJECTS },
    { id: "4", label: TEXT_SITES },
    { id: "6", label: "Documentations" }
  ];

  const unverifiedTabs = [TEXT_PROJECTS, TEXT_SITES, "Product used", "Products Manufactured", "Documentations"];
  const { pathname } = useLocation();

  const [activeTab, setActiveTab] = useState("1"); // For verified manufacturers
  const [unverifiedActiveTab, setUnverifiedActiveTab] = useState(TEXT_PROJECTS); // For unverified
  const [showLoader, setShowLoader] = useState(true);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [showSendInChatModal, setShowSendInChatModal] = useState(false);
  const [noSuchData, setNoSuchData] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [followLoading, setFollowLoading] = useState(false);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIphone = /iPhone/i.test(navigator.userAgent);
  const isIpad = /iPad/i.test(navigator.userAgent);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  let scrollTargetId = "scrollablediv_prodcut";

  const isVerified = manufactureData?.manufactureDetails?.verified;
  const allowPublicProductSubmission =
    manufactureData?.manufactureDetails?.allowPublicProductSubmission;

  useEffect(() => {
    if (pathname?.includes("proxySite")) {
      getProxyPageData();
    } else if (id) {
      getData();
    }
  }, [id, currentUserId, pathname]);

  // All your existing API functions remain the same
  const getProxyPageData = async () => {
    try {
      setShowLoader(true);
      const [manufactureDetails, manufactureAddress, tradeList] = await Promise.all([
        fetchManufactureDetailsForWeb().catch((e) => null),
        getManufactureAddressListForWeb().catch((e) => []),
        getManufactureTradeListForWeb().catch((e) => [])
      ]);

      setManufatureData({
        manufactureDetails,
        manufactureAddress,
        tradeList
      });
      openInPhone();
    } catch (error) {
      console.log("getProxyPageData-> Error While Getting Manufacturer All Detail: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  function openInPhone() {
    if (isAndroid) {
      const androidUrl = `intent://?screenName=${"ManufacturerInfo"}&id=${id}#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
      window.location.replace(androidUrl);
    } else if (isIphone || isIpad) {
      const iPhoneUrl = `mybuilderid://?screenName=${"ManufacturerInfo"}&id=${id}`;
      window.location.replace(iPhoneUrl);
    }
  }

  const fetchManufactureDetailsForWeb = async () => {
    try {
      const res = await Getrequestcall(`${GET_MANUFACTURER_DETAILS_FOR_WEB}/${id}`, undefined);
      let resData = res?.data?.data[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log(
        "fetchManufactureDetailsForWeb-> Error When Getting Manufacturer Detail: ",
        error
      );
    }
  };

  const getManufactureAddressListForWeb = async () => {
    try {
      const obj = {
        SearchList: [{ companyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANY_ADDRESS_FOR_WEB, obj, undefined);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log(
        "getManufactureAddressListForWeb-> Error When Getting Manufactuer Address List: ",
        error
      );
    }
  };

  const getManufactureTradeListForWeb = async () => {
    try {
      let obj = {
        SearchList: [{ CompanyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANY_TRADES_FOR_WEB, obj, undefined);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getManufactureTradeListForWeb-> Error While Fetching Company Trades: ", error);
    }
  };

  const getData = async () => {
    try {
      setShowLoader(true);
      const [manufactureDetails, manufactureAddress, tradeList, followDetails] = await Promise.all([
        fetchManufactureDetails().catch((e) => null),
        getManufactureAddressList().catch((e) => []),
        getManufactureTradeList().catch((e) => []),
        fetchManufactureFollowDetails().catch((e) => null)
      ]);
      setManufatureData({
        manufactureDetails,
        manufactureAddress,
        tradeList,
        followDetails
      });
    } catch (error) {
      console.log("getData-> Error While Getting All Data Of Manufactuer: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  const fetchManufactureDetails = async () => {
    try {
      // OLD API: FETCH_COMPANIES (commented, do not delete)
      // const obj = {
      //   SearchList: [{ Manufacturer: true, id }]
      // };
      // const res = await Postrequestcall(FETCH_COMPANIES, obj, loginData?.accessToken);

      // NEW API: FETCH_COMPANIES_2 (active)
      const obj = {
        UserId: currentUserId,
        SearchString: "",
        PageNumber: 1,
        PageSize: 1,
        Manufacturer: true,
        Id: Number(id) || 0
      };
      const res = await Postrequestcall(FETCH_COMPANIES_2, obj, loginData?.accessToken);
      let resData = res?.data?.data?.[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log("fetchManufactureDetails-> Error While Fetching Manufacture Deatils: ", error);
    }
  };

  const fetchManufactureFollowDetails = async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [
          {
            EntityId: Number(id) || 0,
            EntityTypeId: 3,
            userId: Number(currentUserId)
          }
        ]
      };

      const res = await Postrequestcall(FETCH_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      const followRecord = res?.data?.data?.[0] ?? null;
      return followRecord
        ? {
            ...followRecord,
            id: followRecord?.id ?? followRecord?.followingId ?? 0
          }
        : null;
    } catch (error) {
      console.log("fetchManufactureFollowDetails-> Error When Fetching Follow Details: ", error);
    }
  };

  const getManufactureAddressList = async () => {
    try {
      const obj = {
        SearchList: [{ companyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANIES_ADDRESSES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getManufactureAddressList-> Error While Getting Company Address List: ", error);
    }
  };

  const getManufactureTradeList = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ CompanyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANIES_TRADES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getManufactureTradeList-> Error While Fetching Companies Trade List: ", error);
    }
  };

  const onFollowManufacture = async () => {
    if (!currentUserId || followLoading) return;

    try {
      setFollowLoading(true);
      const nextFollowState = !manufactureData?.followDetails?.isFollowing;
      const followEntityId =
        manufactureData?.followDetails?.id ?? manufactureData?.followDetails?.followingId ?? 0;
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: followEntityId,
            EntityTypeId: 3,
            EntityId: Number(id) || 0,
            UserId: Number(currentUserId),
            IsFollowing: nextFollowState,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      const res = await Postrequestcall(SAVE_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      const savedFollowId =
        res?.data?.data?.[0]?.objData?.id || res?.data?.data?.[0]?.id || followEntityId || 0;
      setManufatureData((prev) => ({
        ...prev,
        followDetails: {
          ...prev?.followDetails,
          isFollowing: nextFollowState,
          id: savedFollowId,
          followingId: savedFollowId
        }
      }));
    } catch (error) {
      console.log("onFollowManufacture-> Error When Saving Follow Status: ", error);
    } finally {
      setFollowLoading(false);
    }
  };

  // All your existing handler functions remain the same
  let isSharing = false;
  const onShareClick = async () => {
    if (navigator.share) {
      if (isSharing) return;

      const shareData = {
        title: "Manufacture Profile",
        url: window.location.href
      };

      isSharing = true;
      navigator
        .share(shareData)
        .catch((error) => console.error("onShareClick-> Error When Trying To Share: ", error))
        .finally(() => {
          isSharing = false;
        });
    } else {
      try {
        try {
          await navigator.clipboard.writeText(window.location.href);
        } catch (err) {
          const textArea = document.createElement("textarea");
          textArea.value = window.location.href;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.body.removeChild(textArea);
        }
        alert("Link copied to clipboard");
        isSharing = false;
      } catch (error) {
        console.log("onShareClick-> Error When Trying To Share (fallback): ", error);
      }
    }
  };

  const onSendChatClick = () => {
    setShowSendInChatModal(true);
  };

  const onTradesSaveSuccessfully = async () => {
    try {
      const resData = await getManufactureTradeList();
      setManufatureData((prevData) => ({
        ...prevData,
        tradeList: resData ?? []
      }));
    } catch (error) {
      console.error("onTradesSaveSuccessfully-> Error When Trying To Save Trade: ", error);
    }
  };

  const onManufactureDetailsSaveSuccessfully = async () => {
    try {
      const resData = await fetchManufactureDetails();
      console.log("resData===========", resData);
      setManufatureData((prevData) => ({
        ...prevData,
        manufactureDetails: resData ?? null
      }));
    } catch (error) {
      console.error(
        "onManufactureDetailsSaveSuccessfully-> Error When Fetching Manufacturer Detail: ",
        error
      );
    }
  };

  const onManufactureAddressSaveSuccessfully = async () => {
    try {
      const resData = await getManufactureAddressList();
      setManufatureData((prevData) => ({
        ...prevData,
        manufactureAddress: resData ?? null
      }));
    } catch (error) {
      console.error(
        "onManufactureAddressSaveSuccessfully-> Error When Fetching Manufactuer Address List: ",
        error
      );
    }
  };

  const onReportClick = () => {
    let reportObj = {
      showReport: true,
      name: Pages?.manufacturers?.name,
      AppScreenId: Pages?.manufacturers?.id,
      recordId: manufactureData?.manufactureDetails?.id,
      isVerified: !!manufactureData?.manufactureDetails?.verified
    };
    dispatch(setShowReport(reportObj));
  };

  if (noSuchData) {
    return (
      <Stack style={{ width: "100%", minHeight: "200px", marginTop: "20px" }}>
        <NoSuchPage />
      </Stack>
    );
  }

  // // Render verified manufacturer layout
  const renderVerifiedLayout = () => (
    <Stack sx={{ p: 2 }}>
      <Card className="main-content-card" sx={{ overflow: "visible" }}>
        <Box className="main-content-card-list" id={scrollTargetId} sx={{ overflow: "visible" }}>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Card sx={{ height: "100%", boxShadow: "none", overflow: "visible" }}>
                <CardHeader sx={{ pb: 0, alignItems: "center" }} action={ !pathname?.includes("proxySite") && ( <Stack direction="row" spacing={1}>
                        <Button
                          variant="outlined"
                          size="small"
                          disabled={followLoading || !currentUserId}
                          onClick={onFollowManufacture}
                          sx={{ minWidth: 96 }}>
                          {manufactureData?.followDetails?.isFollowing ? "Unfollow" : "Follow"}
                        </Button>
                        <IconButton
                          aria-label="settings"
                          onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                          <MoreVertIcon />
                        </IconButton>
                      </Stack>
                    )
                  }
                  avatar={
                    <CardMedia
                      component="img"
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        border: "1px solid #ccc"
                      }}
                      image={
                        manufactureData?.manufactureDetails?.logo ??
                        manufactureData?.manufactureDetails?.imageUrl ??
                        PlaceholderImg
                      }
                      onError={(e) => {
                        e.currentTarget.src = companyPlaceholder;
                        e.currentTarget.onerror = null;
                      }}
                      alt="Manufacturer Logo"
                    />
                  }
                  title={
                    <Stack direction="row" sx={{ alignItems: "center" }} spacing={0.6}>
                      <Typography variant="body1">
                        {manufactureData?.manufactureDetails?.name}
                      </Typography>
                      {manufactureData?.manufactureDetails?.verified && (
                        <VerifiedIcon
                          sx={{
                            color: BIBlue,
                            fontSize: "1.2rem"
                          }}
                        />
                      )}
                    </Stack>
                  }
                  subheader={
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      {TEXT_MANUFACTURER}
                    </Typography>
                  }
                />

                <Box sx={{ width: "100%", typography: "body1" }}>
                  {pathname.includes("proxySite") &&
                  (activeTab === "2" ||
                    activeTab === "3" ||
                    activeTab === "4" ||
                    activeTab === "5") ? (
                    <SignInCard />
                  ) : (
                    <TabContext
                      value={activeTab}
                      variant="scrollable"
                      scrollButtons={false}
                      allowScrollButtonsMobile>
                      <AppBar
                        position="sticky"
                        sx={{
                          top: 0,
                          zIndex: 1100,
                          backgroundColor: "white",
                          boxShadow: "none",
                          borderBottom: 1,
                          marginBottom: "10px",
                          borderColor: "divider"
                        }}>
                        <TabList
                          onChange={(event, newValue) => setActiveTab(newValue)}
                          sx={{
                            "& .MuiTabs-indicator": {
                              backgroundColor: manufactureData?.manufactureDetails?.accentColor
                            },
                            "& .Mui-selected": {
                              color: manufactureData?.manufactureDetails?.accentColor
                            },
                            "& button.MuiButtonBase-root": {
                              color: manufactureData?.manufactureDetails?.accentColor
                            }
                          }}
                          aria-label="lab API tabs example">
                          {verifiedTabs?.map((tab) => (
                            <Tab key={tab.id} label={tab.label} value={tab.id} />
                          ))}
                        </TabList>
                      </AppBar>
                      <TabPanel sx={{ padding: 0 }} value={"1"}>
                        <ManufactureAboutSection
                          color={manufactureData?.manufactureDetails?.accentColor}
                          manufactureDetails={manufactureData?.manufactureDetails}
                          tradeList={manufactureData?.tradeList}
                          manufactureAddress={manufactureData?.manufactureAddress}
                          onTradesSaveSuccessfully={onTradesSaveSuccessfully}
                          isVerified={true}
                          onManufactureDetailsSaveSuccessfully={
                            onManufactureDetailsSaveSuccessfully
                          }
                          onManufactureAddressSaveSuccessfully={
                            onManufactureAddressSaveSuccessfully
                          }
                        />
                      </TabPanel>
                      <TabPanel sx={{ padding: 0 }} value={"2"}>
                        <ManufactureProjectSection
                          manufactureDetails={manufactureData?.manufactureDetails}
                          id={id}
                          scrollId={scrollTargetId}
                          color={manufactureData?.manufactureDetails?.accentColor}
                        />
                      </TabPanel>
                      <TabPanel sx={{ padding: 0 }} value={"3"}>
                        <ManufactureProductSection
                          color={manufactureData?.manufactureDetails?.accentColor}
                          id={id}
                          scrollId={scrollTargetId}
                          manufactureDetails={manufactureData?.manufactureDetails}
                          allowPublicProductSubmission={allowPublicProductSubmission}
                        />
                      </TabPanel>
                      <TabPanel sx={{ padding: 0 }} value={"5"}>
                        <ManufacturedProducts
                          color={manufactureData?.manufactureDetails?.accentColor}
                          id={id}
                          isVerified={true}
                          scrollId={scrollTargetId}
                          isFilterActive={isFilterActive}
                          setIsFilterActive={setIsFilterActive}
                          manufactureDetails={manufactureData?.manufactureDetails}
                          allowPublicProductSubmission={allowPublicProductSubmission}
                        />
                      </TabPanel>
                      <TabPanel sx={{ padding: 0 }} value={"4"}>
                        <ManufacturerSiteSection
                          color={manufactureData?.manufactureDetails?.accentColor}
                          id={id}
                          isVerified={true}
                          scrollId={scrollTargetId}
                          isFilterActive={isFilterActive}
                          setIsFilterActive={setIsFilterActive}
                          manufactureDetails={manufactureData?.manufactureDetails}
                          allowPublicProductSubmission={allowPublicProductSubmission}
                        />
                      </TabPanel>
                      <TabPanel sx={{ padding: 0 }} value={"6"}>
                        <ManufactureDocumentSection
                          id={id}
                          scrollId={scrollTargetId}
                          color={manufactureData?.manufactureDetails?.accentColor}
                        />
                      </TabPanel>
                    </TabContext>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Stack>
  );

  // Render unverified manufacturer layout
  const renderUnverifiedLayout = () => (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Card className="main-content-card">
        <Box className="main-content-card-list" id={scrollTargetId}>
          <Grid container spacing={1.5}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Card className="pagelist-content">
                <CardMedia
                  component="img"
                  height="300"
                  image={manufactureData?.manufactureDetails?.imageUrl ?? PlaceholderImg}
                  alt="Paella dish"
                  onClick={() => setShowImagePreview(true)}
                />
                <CardHeader sx={{ pb: 0, alignItems: "center" }} action={ !pathname?.includes("proxySite") && ( <Stack direction="row" spacing={1}>
                        <Button
                          variant="outlined"
                          size="small"
                          disabled={followLoading || !currentUserId}
                          onClick={onFollowManufacture}
                          sx={{ minWidth: 96 }}>
                          {manufactureData?.followDetails?.isFollowing ? "Unfollow" : "Follow"}
                        </Button>
                        <IconButton
                          aria-label="settings"
                          onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                          <MoreVertIcon />
                        </IconButton>
                      </Stack>
                    )
                  }
                  title={
                    <Typography variant="body1">
                      {manufactureData?.manufactureDetails?.name}
                    </Typography>
                  }
                  subheader={
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      {TEXT_MANUFACTURER}
                    </Typography>
                  }
                />
              </Card>
            </Grid>
          </Grid>

          <Box
            sx={{
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 1200,
              borderBottom: 1,
              marginBottom: "10px",
              borderColor: "divider"
            }}>
            <Tabs
              variant="scrollable"
              scrollButtons={false}
              allowScrollButtonsMobile
              textColor="primary"
              indicatorColor="primary"
              value={unverifiedActiveTab}
              onChange={(event, newTab) => setUnverifiedActiveTab(newTab)}>
              {unverifiedTabs.map((tab, index) => (
                <Tab key={index} value={tab} label={tab} />
              ))}
            </Tabs>
          </Box>
          {console.log("manufactureData: ", unverifiedActiveTab)}
          <Grid container spacing={1.5}>
            <Grid size={{ xs: 12, md: 4 }}>
              <ManufactureAboutSection
                manufactureDetails={manufactureData?.manufactureDetails}
                tradeList={manufactureData?.tradeList}
                manufactureAddress={manufactureData?.manufactureAddress}
                onTradesSaveSuccessfully={onTradesSaveSuccessfully}
                onManufactureDetailsSaveSuccessfully={onManufactureDetailsSaveSuccessfully}
                onManufactureAddressSaveSuccessfully={onManufactureAddressSaveSuccessfully}
              />
            </Grid>
            {console.log("unverifiedActiveTab: ", unverifiedActiveTab)}
            <Grid size={{ xs: 12, md: 8 }}>
              {pathname.includes("proxySite") &&
              (unverifiedActiveTab === TEXT_PROJECTS ||
                unverifiedActiveTab === "Products Manufactured" ||
                unverifiedActiveTab === TEXT_SITES ||
                unverifiedActiveTab === "Documentations" ||
                unverifiedActiveTab === "Product used") ? (
                <SignInCard />
              ) : (
                <>
                  {unverifiedActiveTab === TEXT_PROJECTS && (
                    <ManufactureProjectSection
                      manufactureDetails={manufactureData?.manufactureDetails}
                      id={id}
                      scrollId={scrollTargetId}
                    />
                  )}
                  {unverifiedActiveTab === "Product used" && (
                    <ManufactureProductSection
                      id={id}
                      scrollId={scrollTargetId}
                      manufactureDetails={manufactureData?.manufactureDetails}
                      allowPublicProductSubmission={allowPublicProductSubmission}
                    />
                  )}
                  {unverifiedActiveTab === "Products Manufactured" && (
                    <ManufacturedProducts
                      id={id}
                      scrollId={scrollTargetId}
                      manufactureDetails={manufactureData?.manufactureDetails}
                      isVerified={false}
                      allowPublicProductSubmission={allowPublicProductSubmission}
                    />
                  )}
                  {unverifiedActiveTab === TEXT_SITES && (
                    <ManufacturerSiteSection
                      id={id}
                      scrollId={scrollTargetId}
                      manufactureDetails={manufactureData?.manufactureDetails}
                    />
                  )}
                  {unverifiedActiveTab === "Documentations" && (
                    <ManufactureDocumentSection
                      id={id}
                      scrollId={scrollTargetId}
                      color={manufactureData?.manufactureDetails?.accentColor}
                    />
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Box>
  );

  return (
    <>
      {/* Common Header */}
      {/* {showLoader ? (
        <Pageheader headerName={`${TEXT_MANUFACTURER}`} />
      ) : (
        <Pageheader
          headerName={`${TEXT_MANUFACTURER} | ${manufactureData?.manufactureDetails?.name}`}
        />
      )} */}

      {/* Main Content */}
      {showLoader ? (
        <Card className="main-content-card">
          <Loader />
        </Card>
      ) : (
        <>
          {/* Render different layouts based on verification status */}
          {isVerified ? renderVerifiedLayout() : renderUnverifiedLayout()}
        </>
      )}

      {/* Common Menu */}
      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={() => setMoreMenuAnchorEl(null)}
          transformOrigin={{
            horizontal: "right",
            vertical: "top"
          }}
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom"
          }}>
          {[BUTTON_SEND_IN_CHAT, BUTTON_SHARE, BUTTON_REPORT].map((item, index) => (
            <MenuItem
              onClick={() => {
                if (item === BUTTON_SHARE) {
                  onShareClick();
                } else if (item === BUTTON_SEND_IN_CHAT) {
                  onSendChatClick();
                } else if (item === BUTTON_REPORT) {
                  onReportClick();
                } else {
                  setMoreMenuAnchorEl(null);
                }
                setMoreMenuAnchorEl(null);
              }}
              style={{
                color: item === BUTTON_REPORT ? BIRed : "#083DB8"
              }}
              key={index}
              dense>
              {item}
            </MenuItem>
          ))}
        </Menu>
      )}

      {/* Common Image Preview Modal */}
      {showImagePreview && (
        <PictureViewer
          isOpen={showImagePreview}
          onClose={() => setShowImagePreview(false)}
          src={manufactureData?.manufactureDetails?.imageUrl ?? PlaceholderImg}
        />
      )}

      {/* Common Send in Chat Modal */}
      {showSendInChatModal && (
        <SendInChatModal
          isOpen={showSendInChatModal}
          onClose={() => setShowSendInChatModal(false)}
          fromTo="Manufacture"
          title={manufactureData?.manufactureDetails?.name}
          imageUrl={
            manufactureData?.manufactureDetails?.imageUrl ||
            manufactureData?.manufactureDetails?.logo ||
            PlaceholderImg
          }
        />
      )}
    </>
  );
};

export default ManufactureProfile;
